/**
 * Download each of `urls` through a click on a temporary `<a download>`, with `intervalMs` between two clicks.
 * Resolves after the last click. The browser ignores `download` on a cross-origin URL, so a cross-origin
 * response must send `Content-Disposition: attachment`, or the click navigates the page to it.
 */
export const downloadUrls = async (urls: string[], { intervalMs }: { intervalMs: number }): Promise<void> => {
    for (const [index, url] of urls.entries()) {
        if (index > 0) {
            await new Promise((resolve) => setTimeout(resolve, intervalMs));
        }

        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = '';
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
    }
};
